import { PayloadAction } from '@reduxjs/toolkit';
import { AxiosResponse } from 'axios';
import { ForkEffect, call, put, takeLatest } from 'redux-saga/effects';
import { getBannerApi } from '@/services/TrackingServices';
import { BannerRequest, BannerResponse } from '@/services/types';
import { actionsBanner } from '@/reducers/banner/banner.slice';
import { SagaResponse } from './type';

function* getBanner(action: PayloadAction<BannerRequest>) {
  const response: SagaResponse<AxiosResponse<BannerResponse>> = yield call(
    getBannerApi,
    action.payload,
  );
  if (response.status !== 200) {
    yield put(actionsBanner.getBannerError());
  } else {
    yield put(actionsBanner.getBannerSuccess(response.data));
  }
}

const sagas: ForkEffect<never>[] = [
  takeLatest(actionsBanner.getBannerRequest.type, getBanner),
];

export default sagas;
